import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps) {
    if (this.props.type !== prevProps.type) {
      this.initMenu();
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    var matchingMenuItem = null;
    var ul = document.getElementById("side-menu");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };
  render() {
    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{this.props.t("Menu")}</li>
            <li>
              <Link to="/dashboard">
                <i className="bx bx-home-circle"></i>
                <span>{this.props.t("Dashboard")}</span>
              </Link>
            </li>
            <li>
              <Link to="/companies">
                <i className="bx bx-store"></i>
                <span>{this.props.t("Companies")}</span>
              </Link>
            </li>
            <li>
              <Link to="/departments">
                <i className="bx bx-vector"></i>
                <span>{this.props.t("Departments")}</span>
              </Link>
            </li>
            <li>
              <Link to="/profiles">
                <i className="mdi mdi-account-lock"></i>
                <span>{this.props.t("Profiles")}</span>
              </Link>
            </li>
            <li>
              <Link to="/users">
                <i className="bx bxs-user-detail"></i>
                <span>{this.props.t("Users")}</span>
              </Link>
            </li>
            <li>
              <Link to="/systemusers">
                <i className="bx bx-user-circle"></i>
                <span>{this.props.t("System users")}</span>
              </Link>
            </li>
            <li>
              <Link to="/roles">
                <i className="mdi mdi-account-key-outline"></i>
                <span>{this.props.t("Roles")}</span>
              </Link>
            </li>
            <li>
              <Link to="/insights">
                <i className="mdi mdi-lightbulb-on-outline"></i>
                <span>{this.props.t("Insights")}</span>
              </Link>
            </li>
            <li>
              <Link to="/systemvariables">
                <i className="mdi mdi-iframe-variable-outline"></i>
                <span>{this.props.t("System Variables")}</span>
              </Link>
            </li>
            <li>
              <Link to="/clientsystemvariables">
                <i className="mdi mdi-iframe-outline"></i>
                <span>{this.props.t("Client System Variables")}</span>
              </Link>
            </li>
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(withTranslation()(SidebarContent));
